export const STATUS_PALETTE = {
  sky: { bg: "bg-sky-100 dark:bg-sky-950/60", text: "text-sky-800 dark:text-sky-300", border: "border-sky-300 dark:border-sky-800", dot: "#0ea5e9" },
  blue: { bg: "bg-blue-100 dark:bg-blue-950/60", text: "text-blue-800 dark:text-blue-300", border: "border-blue-300 dark:border-blue-800", dot: "#3b82f6" },
  indigo: { bg: "bg-indigo-100 dark:bg-indigo-950/60", text: "text-indigo-800 dark:text-indigo-300", border: "border-indigo-300 dark:border-indigo-800", dot: "#6366f1" },
  violet: { bg: "bg-violet-100 dark:bg-violet-950/60", text: "text-violet-800 dark:text-violet-300", border: "border-violet-300 dark:border-violet-800", dot: "#8b5cf6" },
  purple: { bg: "bg-purple-100 dark:bg-purple-950/60", text: "text-purple-800 dark:text-purple-300", border: "border-purple-300 dark:border-purple-800", dot: "#a855f7" },
  fuchsia: { bg: "bg-fuchsia-100 dark:bg-fuchsia-950/60", text: "text-fuchsia-800 dark:text-fuchsia-300", border: "border-fuchsia-300 dark:border-fuchsia-800", dot: "#d946ef" },
  pink: { bg: "bg-pink-100 dark:bg-pink-950/60", text: "text-pink-800 dark:text-pink-300", border: "border-pink-300 dark:border-pink-800", dot: "#ec4899" },
  rose: { bg: "bg-rose-100 dark:bg-rose-950/60", text: "text-rose-800 dark:text-rose-300", border: "border-rose-300 dark:border-rose-800", dot: "#f43f5e" },
  red: { bg: "bg-red-100 dark:bg-red-950/60", text: "text-red-800 dark:text-red-300", border: "border-red-300 dark:border-red-800", dot: "#ef4444" },
  orange: { bg: "bg-orange-100 dark:bg-orange-950/60", text: "text-orange-800 dark:text-orange-300", border: "border-orange-300 dark:border-orange-800", dot: "#f97316" },
  amber: { bg: "bg-amber-100 dark:bg-amber-950/60", text: "text-amber-800 dark:text-amber-300", border: "border-amber-300 dark:border-amber-800", dot: "#f59e0b" },
  yellow: { bg: "bg-yellow-100 dark:bg-yellow-950/60", text: "text-yellow-800 dark:text-yellow-300", border: "border-yellow-300 dark:border-yellow-800", dot: "#eab308" },
  lime: { bg: "bg-lime-100 dark:bg-lime-950/60", text: "text-lime-800 dark:text-lime-300", border: "border-lime-300 dark:border-lime-800", dot: "#84cc16" },
  green: { bg: "bg-green-100 dark:bg-green-950/60", text: "text-green-800 dark:text-green-300", border: "border-green-300 dark:border-green-800", dot: "#22c55e" },
  emerald: { bg: "bg-emerald-100 dark:bg-emerald-950/60", text: "text-emerald-800 dark:text-emerald-300", border: "border-emerald-300 dark:border-emerald-800", dot: "#10b981" },
  teal: { bg: "bg-teal-100 dark:bg-teal-950/60", text: "text-teal-800 dark:text-teal-300", border: "border-teal-300 dark:border-teal-800", dot: "#14b8a6" },
  cyan: { bg: "bg-cyan-100 dark:bg-cyan-950/60", text: "text-cyan-800 dark:text-cyan-300", border: "border-cyan-300 dark:border-cyan-800", dot: "#06b6d4" },
  slate: { bg: "bg-slate-100 dark:bg-slate-800", text: "text-slate-700 dark:text-slate-300", border: "border-slate-300 dark:border-slate-700", dot: "#64748b" },
};

export const QUINTO_PRODUCTS = ["cessione del quinto", "delega di pagamento"];
export const isQuinto = (t) => QUINTO_PRODUCTS.includes(String(t || "").trim().toLowerCase());

export function applyStatuses(list) {
  if (!Array.isArray(list) || !list.length) return;
  Object.keys(STATUS_META).forEach((k) => delete STATUS_META[k]);
  list.forEach((s) => { STATUS_META[s.name] = { ...(STATUS_PALETTE[s.color] || STATUS_PALETTE.slate), closed: !!s.closed }; });
}

export const STATUS_META = {
  "Presentata": { bg: "bg-sky-100 dark:bg-sky-950/60", text: "text-sky-800 dark:text-sky-300", border: "border-sky-300 dark:border-sky-800", dot: "#0ea5e9" },
  "In attesa Documenti": { bg: "bg-amber-100 dark:bg-amber-950/60", text: "text-amber-800 dark:text-amber-300", border: "border-amber-300 dark:border-amber-800", dot: "#f59e0b" },
  "Esame Interno": { bg: "bg-indigo-100 dark:bg-indigo-950/60", text: "text-indigo-800 dark:text-indigo-300", border: "border-indigo-300 dark:border-indigo-800", dot: "#6366f1" },
  "Sospesa": { bg: "bg-orange-100 dark:bg-orange-950/60", text: "text-orange-800 dark:text-orange-300", border: "border-orange-300 dark:border-orange-800", dot: "#f97316" },
  "Approvata": { bg: "bg-emerald-100 dark:bg-emerald-950/60", text: "text-emerald-800 dark:text-emerald-300", border: "border-emerald-300 dark:border-emerald-800", dot: "#10b981" },
  "Respinta": { bg: "bg-rose-100 dark:bg-rose-950/60", text: "text-rose-800 dark:text-rose-300", border: "border-rose-300 dark:border-rose-800", dot: "#f43f5e" },
  "Ritirata": { bg: "bg-slate-100 dark:bg-slate-800", text: "text-slate-700 dark:text-slate-300", border: "border-slate-300 dark:border-slate-700", dot: "#64748b" },
  "In Liquidazione": { bg: "bg-cyan-100 dark:bg-cyan-950/60", text: "text-cyan-800 dark:text-cyan-300", border: "border-cyan-300 dark:border-cyan-800", dot: "#06b6d4" },
  "Liquidata": { bg: "bg-teal-100 dark:bg-teal-950/60", text: "text-teal-800 dark:text-teal-300", border: "border-teal-300 dark:border-teal-800", dot: "#14b8a6" },
};

export const ROLE_LABELS = {
  admin: "Amministratore",
  collaboratore: "Collaboratore Interno",
  convenzionato: "Convenzionato",
  segnalatore: "Segnalatore",
  istituto: "Istituto Finanziario",
};

export const DOC_TAG_LABELS = {
  CARTA_IDENTITA: "Carta d'Identità",
  BUSTA_PAGA: "Busta Paga",
  MODELLO_REDDITI: "Modello Redditi",
  CONTRATTO: "Contratto",
  DOC_FIRMATI: "Documenti firmati",
  ALTRO: "Altro",
};

export function fmtEuro(v) {
  const n = Math.round((Number(v) || 0) * 100) / 100;
  const d = Number.isInteger(n) ? 0 : 2;
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: d, maximumFractionDigits: 2, useGrouping: "always" }).format(n);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function isInternal(role) {
  return role === "admin" || role === "collaboratore";
}

export function cleanPhone(v) {
  if (v == null) return "";
  const s = String(v).trim();
  return s.endsWith(".0") ? s.slice(0, -2) : s;
}
